import { Box, ColorOptions, LoaderNew, ModBox, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { ButtonNew } from '../../../../components/AdminButton'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { ScrollView } from 'react-native'
import { Dropdown } from '../../../../components/Dropdown'
import { ModalAlertView } from '../../../../components/ModalAlertView'
import Tabbar, { TabbarType } from '../../../../components/Tabbar'
import { useLazyApiData, useStores } from '../../../../data/store'
import { checkDropdownData } from '../../../../utils/constants'
import { SelectParentEntityList } from '../../Onboarding/CreateEntity/SelectParentEntityList'
import { DocumentationView } from '../../Onboarding/Documentation/View'
import {
  checkerFlexMap,
  checkerHeaderData,
  checkerNewOldFlexMap,
  checkerNewOldHeaderData,
} from '../../Onboarding/Documentation/form'
import { styles } from '../Checker'
import { Header } from '../Comps/Header'
import AadharRedactionStatus from '../Status'

interface AadharRedactionDetailsProps {
  route: any
}
const defaultTitles = [{ title: 'Non-Edited' }, { title: 'Edited' }]

const Footer = ({ show, onSubmit }: any) => {
  const [status, setStatus] = useState('')
  const [comments, setComments] = useState('')
  const isFocus = useIsFocused()

  const onDropDownChange = (selected: string) => {
    setStatus(selected)
  }

  const onHandleSubmit = () => {
    onSubmit && onSubmit(status, comments)
  }

  useEffect(() => {
    if (isFocus && (status !== '' || comments !== '')) {
      setComments('')
      setStatus('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!show) {
    return null
  }
  return (
    <ScrollView>
      <Box {...styles.footer}>
        <Box w={'100%'} alignItems={'center'} justifyContent={'space-between'} direction="row">
          <Box direction="row">
            <Box h={52}>
              <Text title={'Status'} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_75'} />
              <Spacer direction="vertical" size={8} />
              <Box borderWidth={1} borderColor={'BORDER_COLOR'} borderRadius={4}>
                <Dropdown
                  minHeight={32}
                  minWidth={150}
                  testID="selectStatus"
                  title={'Select Status'}
                  selectedData={onDropDownChange}
                  data={checkDropdownData}
                  value={status}
                  transparentBorder={true}
                />
              </Box>
            </Box>
            <Box marginLeft={16} width={367}>
              <Text title={"Checker's Comments"} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_75'} />
              <Spacer direction="vertical" size={8} />
              <Box
                borderWidth={1}
                borderColor={'BORDER_COLOR'}
                borderRadius={4}
                overflow={'auto'}
                nativeID="vertical-scroll"
                height={72}>
                <TextInputNew
                  placeholder={'Write your comments here...'}
                  value={comments}
                  onChangeText={setComments}
                  focusBorderColor={'TRANSPARENT'}
                  labelFontFamily={'jiotype-medium'}
                  fontSize={12}
                  paddingHorizontal={8}
                  paddingVertical={8}
                  numberOfLines={4}
                  multiline
                  maxLength={4096}
                />
              </Box>
            </Box>
          </Box>
          <ButtonNew
            onPress={onHandleSubmit}
            title={'Submit'}
            height={40}
            width={94}
            color={comments?.length === 0 || status?.length === 0 ? '#B9D3E7' : 'PRIMARY'}
            disabled={comments?.length === 0 || status?.length === 0}
          />
        </Box>
      </Box>
    </ScrollView>
  )
}

const AadharRedactionDetails = ({ route }: AadharRedactionDetailsProps) => {
  const { from, type, itemData, isApprovedByChecker, showApproveReject = false } = route?.params ?? {}

  const {
    approveRejectTask,
    setSideMenuRefresh,
    kycDocumentsList,
    uploadId,
    getEditedDocs,
    fetchNonEditedDocs,
    getNonEditedDocs,
  } = useStores((store) => ({
    approveRejectTask: store.processFiuData,
    setSideMenuRefresh: store.setSideMenuRefresh,
    kycDocumentsList: store.kycDocumentsList,
    uploadId: store.onboarding.uploadId,
    getEditedDocs: store.getEditedDocuments,
    fetchNonEditedDocs: store.getDocumentsList,
    getNonEditedDocs: store.getNonEditedDocuments,
  }))

  const [fetchApproveRejectTask, fetchApproveRejectTaskHandler] = useLazyApiData(approveRejectTask)
  const [fetchEditedKycDocsList, fetchKycDocsHandler] = useLazyApiData(kycDocumentsList)
  const [fetchNonEditedDocsList, fetchNonEditedDocsHandler] = useLazyApiData(fetchNonEditedDocs)
  const [isCheckerApproved, setCheckerApproved] = useState(isApprovedByChecker)
  const [showCheckerStatus, setShowCheckerStatus] = useState(
    from && (from === 'AD_CHECKER' || from === 'AD_MAKER') ? isApprovedByChecker : false,
  )
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const [approveRejectData, setApproveRejectData] = useState(
    from && (from === 'AD_CHECKER' || from === 'AD_MAKER')
      ? { apiResponse: {}, data: itemData }
      : { apiResponse: {}, data: {} },
  )
  const [headerData, setHeaderData] = useState({
    id: itemData?.applicationId ?? '',
  })
  const [showAlertInfo, setShowAlertInfo] = useState(false)
  const navigation = useNavigation()
  const [showConfirmAlert, setShowConfirmAlert] = useState(false)
  const [checkerData, setCheckerData] = useState({ value: '', comments: '' })
  const [docsList, setDocsList] = useState([])
  const [showDocViewModal, setShowDocViewModal] = useState(false)
  const [selectedItemData, setSelectedItemData] = useState(null)

  useEffect(() => {
    if (!itemData) {
      navigation.reset({
        index: 0,
        routes: [{ name: 'aadharRedaction' }],
      })
    }
  }, [itemData])

  useEffect(() => {
    if (itemData && itemData?.identificationNumber?.length > 0) {
      fetchNonEditedDocsList(itemData?.identificationNumber, true, true, 'AADHAR_REDACTION')
    }
    if (itemData && itemData?.uploadId?.length > 0 && itemData?.applicationStatus !== 'Completed') {
      fetchEditedKycDocsList(
        itemData?.uploadId,
        'REDACT',
        itemData?.applicationStatus === 'Rejected' ? 'REJECTED_TO_BE_DELETED' : 'ACTIVE',
      )
    }
  }, [fetchEditedKycDocsList, fetchNonEditedDocsList, itemData])

  useEffect(() => {
    if (fetchKycDocsHandler?.state === 'fulfilled' || fetchNonEditedDocsHandler?.state === 'fulfilled') {
      if (selectedTabIndex === 1) {
        const list = getEditedDocs()
        setDocsList(list)
      } else if (selectedTabIndex === 0) {
        const list = getNonEditedDocs(from, itemData?.applicationStatus)
        setDocsList(list)
      }
    }
  }, [
    fetchKycDocsHandler?.state,
    fetchNonEditedDocsHandler?.state,
    from,
    getEditedDocs,
    getNonEditedDocs,
    itemData?.applicationStatus,
    selectedTabIndex,
  ])

  useEffect(() => {
    if (fetchApproveRejectTaskHandler?.state === 'fulfilled') {
      if (!showCheckerStatus) {
        setShowCheckerStatus(true)
        setApproveRejectData({ apiResponse: fetchApproveRejectTaskHandler?.data, data: itemData })
      }
    }
  }, [fetchApproveRejectTaskHandler?.data, fetchApproveRejectTaskHandler?.state, itemData, showCheckerStatus])

  const onApproveReject = (value: string, comments: string) => {
    setCheckerApproved(value === 'Approved')
    setShowConfirmAlert(true)
    setCheckerData({ value: value, comments: comments })
  }

  const onNavigateToMyqueue = () => {
    setCheckerApproved(false)
    if (from === 'AD_CHECKER') {
      navigation.reset({
        index: 0,
        routes: [{ name: 'aadharCheckerQueue' }],
      })
    } else if (from === 'AD_MAKER') {
      navigation.reset({
        index: 0,
        routes: [{ name: 'aadharMakerQueue' }],
      })
    }
    setSideMenuRefresh(true)
  }

  const onTabSelected = (selectedIndex: number) => {
    if (selectedIndex === 1) {
      setShowAlertInfo(true)
    } else {
      setSelectedTabIndex(selectedIndex)
      const list = getNonEditedDocs(from, itemData?.applicationStatus)
      setDocsList(list)
    }
  }

  const onCheckChange = (isChecked: string) => {
    console.log('isChecked:', isChecked)
  }

  const handleApiOnConfirm = () => {
    if (checkerData?.value?.length > 0 && checkerData?.comments?.length > 0) {
      fetchApproveRejectTask(itemData?.applicationId, checkerData?.value, checkerData?.comments, 'AADHAR_REDACTION')
    }
  }

  const onBackPress = () => {
    setShowDocViewModal(false)
  }

  const handleItemPress = (data: any) => {
    console.log('handleItemPress data: ', data)
    setShowDocViewModal(true)
    setSelectedItemData({ isEdit: selectedTabIndex === 1, from: from, ...data })
  }

  const setData = () => {
    const list = getEditedDocs()
    setDocsList(list)
  }
  return (
    <>
      <ModBox
        h={'100%'}
        minHeight={550}
        alignItems={'center'}
        justifyContent={'center'}
        show={
          fetchApproveRejectTaskHandler?.state === 'pending' ||
          fetchKycDocsHandler?.state === 'pending' ||
          fetchNonEditedDocsHandler?.state === 'pending'
        }>
        <LoaderNew type={'small'} color={'PRIMARY'} />
      </ModBox>
      <ModBox show={!showCheckerStatus} {...styles.container}>
        <Header
          from={from}
          navigation={navigation}
          setSideMenuRefresh={setSideMenuRefresh}
          applicationId={itemData?.applicationId}
          headerData={headerData}
          status={itemData?.applicationStatus}
        />
        <ModBox>
          <ModBox
            show={itemData?.makerComments?.length > 0}
            w={'100%'}
            h={30}
            backgroundColor={'#CC7F000F' as ColorOptions}
            direction="row"
            paddingHorizontal={32}
            alignItems={'center'}>
            <Text
              title={'Maker’s Comments: '}
              color={'#CC7F00' as ColorOptions}
              fontSize={12}
              fontFamily={'jiotype-medium'}
            />
            <Text title={itemData?.makerComments} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-medium'} />
          </ModBox>
          <ModBox
            h={'100%'}
            minHeight={550}
            marginHorizontal={32}
            marginTop={16}
            show={
              fetchApproveRejectTaskHandler?.state !== 'pending' ||
              fetchKycDocsHandler?.state !== 'pending' ||
              fetchNonEditedDocsHandler?.state !== 'pending'
            }>
            <ModBox>
              <ModBox marginVertical={16}>
                <Text
                  title={from === 'AD_CHECKER' ? 'Checker Queue Details' : 'Maker Queue Details'}
                  color={'BLACK_21'}
                  fontSize={18}
                  fontFamily={'jiotype-bold'}
                />
              </ModBox>
              <ModBox
                {...styles.tabbarView}
                w={'100%'}
                show={itemData?.applicationStatus !== 'Completed' && itemData?.applicationStatus !== 'Error'}>
                <Tabbar
                  titles={defaultTitles}
                  default={selectedTabIndex}
                  type={TabbarType.bulkEntity}
                  onSelected={onTabSelected}
                />
              </ModBox>
              <ModBox
                marginVertical={16}
                h={380}
                w={'100%'}
                show={docsList?.length > 0}
                testID="vertical-scroll"
                overflow={'auto'}>
                <SelectParentEntityList
                  title={''}
                  hide={false}
                  data={docsList}
                  headerTitles={selectedTabIndex === 0 ? checkerHeaderData : checkerNewOldHeaderData}
                  columnFlexMapper={selectedTabIndex === 0 ? checkerFlexMap : checkerNewOldFlexMap}
                  onItemPress={handleItemPress}
                />
              </ModBox>
            </ModBox>
          </ModBox>
        </ModBox>
        <ModBox backgroundColor={'WHITE'} show={showApproveReject}>
          <Footer
            show={from !== undefined || from === 'AD_CHECKER' || from === 'AD_MAKER'}
            onSubmit={onApproveReject}
          />
        </ModBox>
        <ModBox
          marginHorizontal={32}
          show={
            itemData && (itemData?.applicationStatus === 'Completed' || itemData?.applicationStatus === 'Rejected')
          }>
          <Text
            title={`Checker Comments: ${itemData?.comments}`}
            color={'BLACK_21'}
            fontSize={14}
            fontFamily={'jiotype-medium'}
          />
        </ModBox>
        <ModalAlertView
          message='Make sure all the "Non edited documents" are
          properly checked and Maker has committed
          document editing for all the relevant documents.'
          show={showAlertInfo}
          showHeader={false}
          title={''}
          buttonTitle={'I have checked properly'}
          cancelTitle={'Go Back'}
          onDismiss={() => setShowAlertInfo(false)}
          onPress={() => [setSelectedTabIndex(1), setShowAlertInfo(false), setData()]}
          onCancel={() => [setSelectedTabIndex(0), setShowAlertInfo(false)]}
          positiveButtonColor={'PRIMARY'}
          cancelButtonColor={'WHITE'}
          height={60}
          width={400}
        />
      </ModBox>
      <ModalAlertView
        message={
          isCheckerApproved
            ? 'Are you sure you want to approve the request?'
            : 'Are you sure you want to reject the request?'
        }
        show={showConfirmAlert}
        showHeader={false}
        title={''}
        buttonTitle={isCheckerApproved ? 'Approve' : 'Reject'}
        cancelTitle={'Dismiss'}
        onDismiss={() => setShowConfirmAlert(false)}
        onPress={() => [handleApiOnConfirm(), setShowConfirmAlert(false)]}
        onCancel={() => setShowConfirmAlert(false)}
        positiveButtonColor={isCheckerApproved ? 'PRIMARY' : '#CA4848'}
        cancelButtonColor={'WHITE'}
        height={80}
        width={400}
        isConfirmationCheckRequired={true}
        onCheckChange={onCheckChange}
      />
      <ModBox show={showCheckerStatus}>
        <AadharRedactionStatus
          isCheckerApproved={isCheckerApproved}
          data={approveRejectData}
          onSubmit={onNavigateToMyqueue}
        />
      </ModBox>
      <ModalDialog
        type="CenteredWrap"
        children={
          <ScrollView nestedScrollEnabled contentContainerStyle={{ alignItems: 'flex-start' }}>
            <DocumentationView
              entityId={itemData?.identificationNumber}
              documentName={selectedItemData?.NAME ?? ''}
              type={
                selectedItemData?.NAME?.includes('.pdf') || selectedItemData?.NAME?.includes('.PDF')
                  ? 'PDF'
                  : selectedItemData?.NAME?.includes('.png') || selectedItemData?.NAME?.includes('.PNG')
                  ? 'PNG'
                  : selectedItemData?.NAME?.includes('.jpg') || selectedItemData?.NAME?.includes('.JPG')
                  ? 'JPG'
                  : selectedItemData?.NAME?.includes('.JPEG') || selectedItemData?.NAME?.includes('.jpeg')
                  ? 'JPG'
                  : `${selectedItemData?.NAME?.split('.')?.[1]}`
              }
              onBackPress={onBackPress}
              item={selectedItemData}
              flowType={type}
            />
          </ScrollView>
        }
        show={showDocViewModal}
        onDismiss={() => setShowDocViewModal(false)}
        onClose={() => setShowDocViewModal(false)}
      />
    </>
  )
}

export default AadharRedactionDetails
